export enum CardType {
	eSim,
	Physical,
	NonType,
}
